<template lang="html">

  <nav class="migas row-start">
    <router-link to="/" v-if="!!!inicioPersonalizado">{{$t('inicio')}}</router-link>
    <router-link :to="inicioPersonalizado" v-else>{{$t('inicio')}}</router-link>
    
    <template v-if="inOrientacion">
        <router-link to="/orientacion" v-if="inOrientacion">{{$t(`encabezado.orientacion`)}}</router-link>
    </template>

    <template v-if="!inOferta & !inCVCandidato">
      <router-link :to="view">{{$t(`encabezado.${$route.meta.name}`)}}</router-link>
    </template>

    <template v-if="inOferta || inCVCandidato">

        <router-link to="/mis-ofertas" v-if="inCVCandidato">{{$t(`encabezado.mis_ofertas`)}}</router-link>

        <template v-if="!inCVCandidato">

          <router-link v-if="$route.meta.name == 'candidaturas'" :to="$t('enlaces.mis_candidaturas')">{{$t(`encabezado.mis_candidaturas`)}}</router-link>

          <router-link v-else :to="'/'+$route.fullPath.split('/')[1]">{{$t(`encabezado.${$route.meta.name}`)}}</router-link>

        </template>

    </template>

    <router-link v-if="!!last" class="last" :to="$route.fullPath">{{$t(`encabezado.${$route.meta.name}`)}}</router-link>

    <router-link v-if="!!lastPersonalizado" class="last" :to="$route.fullPath">{{lastPersonalizado}}</router-link>
  </nav>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'migas',
    props : ['last','inicioPersonalizado','lastPersonalizado'],
    computed : {
      ...mapGetters({
        style : 'getStyles',
        colors : 'basicColors'
      }),
      view : function(){
        let url = this.$route.path.split("/");
        url = url.pop();
        url = '/'+url;
        return url;
      },
      inOferta : function(){
        return (this.$route.meta.isOferta);
      },
      inCVCandidato : function(){
        return (this.$route.name == 'cv-view');
      },      
      inOrientacion : function(){
        return (this.$route.name == 'solicitar_orientacion' || this.$route.name == 'recursos' || this.$route.name == 'ficha_recurso' || 
                this.$route.name == 'talleres_orientacion' || this.$route.name == 'ficha_taller' || this.$route.name == 'testimoniales_orientacion' || this.$route.name == 'ficha_testimonial');
      },
    }
  }
</script>

<style scoped lang="scss">

@import '@/assets/css/colors.scss';

.migas a{
  font-size: 14px;
  line-height: 20px;
}

.migas a{
  color: currentColor;
}

.migas a::after{
  content: '>';
  padding-right: 5px;
  margin-left: 5px;
  display: inline-block;
  font-size: 16px;
  line-height: 20px;
}

.migas a:last-of-type::after{
  display: none;
}

.migas-ficha .migas{
  padding-top: 10px;
}

@media screen and (max-width: 700px){
  .migas .last{
    display: none;
  }

  .migas a:nth-child(2)::after{
    display: none;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/parts/migas.vue